import styled from "styled-components";

export const NotificationLoading = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  .icon-loading-notification {
    height: 4rem;
    width: 4rem;
  }
`;
export const DivContentDocument = styled.div`
  align-items: center;
  background: #ffffff;
  box-shadow: 0px 2px 15px rgba(167, 167, 167, 0.3);
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
`;

interface IDivContentHead {
  paddingBottom?: string;
}
export const DivContentHead = styled.div<IDivContentHead>`
  ${(props) => `
      padding-bottom: ${props.paddingBottom ? props.paddingBottom : "0rem"};
 `}
  align-items: center;
  cursor: pointer;
  display: flex;

  padding-top: 2rem;
  width: 100%;
`;
export const DivContentSymbol = styled.div`
  background: rgba(0, 109, 255, 0.1);
  border-radius: 20px;
  color: #0068f3;
  font-weight: 700;
  margin-left: 1.7rem;
  padding: 0.5rem;
`;

export const DivContentLabel = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  color: #575757;
  font-size: 1.2rem;
  font-weight: 600;
  margin-left: 0.7rem;
  margin-right: 0.7rem;
`;

export const DivContentCount = styled.div`
  background: #c4c4c4;
  color: #ffffff;
  border-radius: 20px;
  font-weight: 600;
  height: 1.6rem;
  width: 1.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1.48rem;
`;
